import React from "react";
import { AnimatePresence } from "framer-motion";
import Toast from "./Toast";

const ToastContainer = ({ toasts, darkMode = true }) => {
  return (
    <div className="fixed top-4 right-4 z-[99999] flex flex-col gap-3 pointer-events-none">
      <AnimatePresence initial={false}>
        {toasts.map((toast) => (
          <Toast key={toast.id} message={toast.message} type={toast.type} darkMode={darkMode} />
        ))}
      </AnimatePresence>
    </div>
  );
};

export default ToastContainer;
